import { xor } from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import { getOrgTermsContent } from '../../../../content/utils.js';
import { RATINGS } from '../../../../lib/schema.js';
import { navigateToProjectReports } from '../../../links/index.jsx';
import RatingLabel from '../../../RatingLabel.jsx';

const IMPACTS = RATINGS.HIGH_MEDIUM_LOW;

ProjectImpactFilter.propTypes = {
  selectedProjectImpacts: PropTypes.arrayOf(PropTypes.oneOf(IMPACTS)),
};

ProjectImpactFilter.defaultProps = {
  selectedProjectImpacts: [],
};

function ProjectImpactFilter({ selectedProjectImpacts }) {
  const selectedCount = selectedProjectImpacts.length;

  const handleSelect = useCallback(
    (impact) =>
      navigateToProjectReports({
        projectImpact: impact ? xor(selectedProjectImpacts, [impact]) : [],
      }),
    [selectedProjectImpacts]
  );

  const renderMenuItem = useCallback(
    (impact) => (
      <React.Fragment key={impact}>
        <MenuItem
          active={selectedProjectImpacts.includes(impact)}
          eventKey={impact}
          onSelect={handleSelect}
        >
          <RatingLabel rating={impact} reverse />
        </MenuItem>
      </React.Fragment>
    ),
    [selectedProjectImpacts]
  );

  return (
    <div className="flex-col report-filter">
      <div className="text-muted filter-label">
        {getOrgTermsContent('projectImpact')}
      </div>
      <ButtonToolbar>
        <DropdownButton
          bsStyle="info"
          title={selectedCount ? `${selectedCount} Selected` : 'All'}
          id="impact-filter"
          className="btn-block"
          onSelect={handleSelect}
          pullRight
        >
          <MenuItem active={selectedCount === 0}>All</MenuItem>
          <MenuItem divider />
          {IMPACTS.map(renderMenuItem)}
        </DropdownButton>
      </ButtonToolbar>
    </div>
  );
}

export default ProjectImpactFilter;
